import type { WorkspaceScreen } from '../../lib/workspaceContext';
import type { EditorCounselMode } from '../../store/lexCounselStore';

export function screenPlaceholder(screen?: WorkspaceScreen): string {
  switch (screen) {
    case 'dashboard':
      return 'Ask about hearings, reminders, or pending drafts…';
    case 'calendar':
      return 'Ask about your schedule or priorities…';
    case 'templates':
      return 'Ask about templates or starting a document…';
    case 'settings':
      return 'Ask about LexGat features…';
    case 'draft_editor':
      return 'Redraft a clause, ask about the draft…';
    case 'case':
      return 'Ask about this case…';
    default:
      return 'Ask Lex Counsel…';
  }
}

export function editorCounselModePlaceholder(mode: EditorCounselMode): string {
  switch (mode) {
    case 'draft':
      return 'Redraft a clause, add a prayer, improve selection…';
    case 'review':
      return 'Run Filing Review — senior advocate pre-filing QA across all tabs…';
    default:
      return 'Ask about procedure, case facts, or this document…';
  }
}

const EDITOR_MODES: { id: EditorCounselMode; label: string }[] = [
  { id: 'ask', label: 'Ask' },
  { id: 'draft', label: 'Draft' },
  { id: 'review', label: 'Review' },
];

type ModePickerProps = {
  mode: EditorCounselMode;
  onChange: (mode: EditorCounselMode) => void;
  disabled?: boolean;
};

export function LexCounselEditorModePicker({ mode, onChange, disabled }: ModePickerProps) {
  return (
    <div
      className="flex w-fit items-center gap-0.5 rounded-full border border-[var(--counsel-border)] bg-[var(--counsel-chip-bg)] p-0.5"
      role="tablist"
      aria-label="Lex Counsel mode"
    >
      {EDITOR_MODES.map((item) => {
        const active = mode === item.id;
        return (
          <button
            key={item.id}
            type="button"
            role="tab"
            aria-selected={active}
            disabled={disabled}
            onClick={() => onChange(item.id)}
            className={`rounded-full px-3 py-1 text-xs font-medium transition-colors disabled:opacity-40 ${
              active
                ? 'bg-[var(--counsel-mode-active-bg)] text-[var(--counsel-mode-active-text)]'
                : 'text-[var(--counsel-text-muted)] hover:text-[var(--counsel-text)]'
            }`}
          >
            {item.label}
          </button>
        );
      })}
    </div>
  );
}

/** @deprecated Modes removed — use screenPlaceholder */
export function modePlaceholder(_mode: unknown, screen?: WorkspaceScreen): string {
  return screenPlaceholder(screen);
}

export function LexCounselModeDropdown() {
  return null;
}

export default function LexCounselModeBar() {
  return null;
}
